class SorellaCustomHeader extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready) return;
    this.dataset.ready = 'true';
    this.overlay = this.querySelector('[data-overlay]');
    this.drawers = [...this.querySelectorAll('.dh__drawer')];
    this.megaTriggers = [...this.querySelectorAll('[data-mega-trigger]')];
    this.searchResults = this.querySelector('[data-search-results]');
    this.defaultSearchMarkup = this.searchResults?.innerHTML || '';
    try {
      this.searchIndex = JSON.parse(this.querySelector('[data-sorella-search-index]')?.textContent || '[]');
    } catch (_) {
      this.searchIndex = [];
    }
    this.searchSequence = 0;
    this.onKeydown = this.onKeydown.bind(this);
    document.addEventListener('keydown', this.onKeydown);
    this.startAnnouncement();

    this.megaTriggers.forEach((button) => button.addEventListener('click', () => this.toggleMega(button)));
    this.querySelectorAll('[data-open-mobile]').forEach((el) => el.addEventListener('click', () => this.openDrawer('mobile')));
    this.querySelectorAll('[data-open-search]').forEach((el) => el.addEventListener('click', () => this.openDrawer('search')));
    this.querySelectorAll('[data-open-cart]').forEach((el) => el.addEventListener('click', () => { this.openDrawer('cart'); this.loadCart(); }));
    this.querySelector('[data-cart-content]')?.addEventListener('click', (event) => {
      const control = event.target.closest('[data-cart-change]');
      if (control) this.changeCart(control.dataset.key, Number(control.dataset.quantity));
      const groupControl = event.target.closest('[data-cart-remove-group]');
      if (groupControl) this.removeCartGroup(groupControl.dataset.cartRemoveGroup);
      const sampleTrigger = event.target.closest('[data-open-samples]');
      if (sampleTrigger) this.openSamples();
    });
    this.querySelectorAll('[data-close]:not([data-open-search])').forEach((el) => el.addEventListener('click', () => this.closeDrawers()));
    this.overlay.addEventListener('click', () => this.closeDrawers());
    this.querySelectorAll('[data-open-benefits]').forEach((el) => el.addEventListener('click', () => this.openBenefits()));
    this.querySelector('[data-close-benefits]')?.addEventListener('click', () => this.querySelector('[data-benefits-dialog]').close());
    this.sampleDialog = this.querySelector('[data-sample-dialog]');
    try { this.rewardPolicy = JSON.parse(this.querySelector('[data-sorella-reward-policy]')?.textContent || 'null'); } catch (_) { this.rewardPolicy = null; }
    this.onCheckout = this.guardCheckout.bind(this);
    document.addEventListener('submit', this.onCheckout, true);
    this.querySelector('[data-close-samples]')?.addEventListener('click', () => this.sampleDialog?.close());
    this.sampleDialog?.addEventListener('click', (event) => {
      if (event.target === this.sampleDialog) this.sampleDialog.close();
      const sample = event.target.closest('[data-sample-add]');
      if (sample) this.addFreeSample(sample.dataset.variantId, sample);
    });

    const input = this.querySelector('[data-search-input]');
    if (input) input.addEventListener('input', this.debounce(() => this.predict(input.value), 220));
    document.addEventListener('click', (event) => {
      if (!this.contains(event.target)) this.closeMega();
    });
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.onKeydown);
    document.removeEventListener('submit', this.onCheckout, true);
    window.clearTimeout(this.samplePromptTimer);
    window.clearTimeout(this.announcementTimer);
    window.clearTimeout(this.announcementSwapTimer);
    window.clearTimeout(this.announcementFadeTimer);
    window.clearTimeout(this.announcementCycleTimer);
    if (this.announcementText) {
      this.announcementText.textContent = this.announcementText.dataset.message || '';
      this.announcementText.classList.remove('is-typing', 'is-changing');
      this.announcementBar?.classList.remove('is-offer', 'is-offer--sample', 'is-offer--shipping');
    }
  }

  startAnnouncement() {
    this.announcementText = this.querySelector('[data-announcement-typewriter]');
    if (!this.announcementText) return;
    const message = this.announcementText.dataset.message || this.announcementText.textContent.trim();
    const offerMessages = [
      { text: this.announcementText.dataset.sampleMessage || '', state: 'sample' },
      { text: this.announcementText.dataset.shippingMessage || '', state: 'shipping' }
    ].filter((offer) => offer.text);
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.announcementBar = this.querySelector('[data-announcement-bar]');
    this.announcementLive = this.querySelector('[data-announcement-live]');
    let offerIndex = 0;

    const showNextOffer = () => {
      if (!offerMessages.length) return;
      const offer = offerMessages[offerIndex];
      offerIndex = (offerIndex + 1) % offerMessages.length;
      const applyOffer = () => {
        this.announcementText.textContent = offer.text;
        this.announcementText.classList.remove('is-changing');
        this.announcementBar?.classList.remove('is-offer--sample', 'is-offer--shipping');
        this.announcementBar?.classList.add('is-offer', `is-offer--${offer.state}`);
        this.announcementBar?.setAttribute('aria-label', offer.text);
        if (this.announcementLive) this.announcementLive.textContent = offer.text;
        if (offerMessages.length > 1) {
          this.announcementCycleTimer = window.setTimeout(showNextOffer, reduceMotion ? 5000 : 3200);
        }
      };

      if (reduceMotion) {
        applyOffer();
        return;
      }

      this.announcementText.classList.add('is-changing');
      this.announcementFadeTimer = window.setTimeout(applyOffer, 180);
    };

    const scheduleOffer = () => {
      if (!offerMessages.length) return;
      this.announcementSwapTimer = window.setTimeout(showNextOffer, 2000);
    };

    if (!message || reduceMotion) {
      this.announcementText.textContent = message;
      scheduleOffer();
      return;
    }

    let character = 0;
    this.announcementText.textContent = '';
    this.announcementText.classList.add('is-typing');
    const typeNextCharacter = () => {
      character += 1;
      this.announcementText.textContent = message.slice(0, character);
      if (character < message.length) {
        this.announcementTimer = window.setTimeout(typeNextCharacter, 46);
      } else {
        this.announcementText.classList.remove('is-typing');
        scheduleOffer();
      }
    };
    this.announcementTimer = window.setTimeout(typeNextCharacter, 220);
  }

  toggleMega(button) {
    const key = button.dataset.megaTrigger;
    const panel = this.querySelector(`[data-mega="${key}"]`);
    const opening = panel.hasAttribute('hidden');
    this.closeMega();
    if (opening) {
      panel.removeAttribute('hidden');
      button.setAttribute('aria-expanded', 'true');
    }
  }

  closeMega() {
    this.querySelectorAll('[data-mega]').forEach((panel) => panel.hidden = true);
    this.megaTriggers.forEach((button) => button.setAttribute('aria-expanded', 'false'));
  }

  openDrawer(type) {
    this.closeMega();
    this.lastFocus = document.activeElement;
    const drawer = this.querySelector(`[data-${type}-drawer]`);
    if (!drawer) return;
    if (type === 'mobile') drawer.querySelectorAll('details[open]').forEach((details) => details.removeAttribute('open'));
    drawer.scrollTop = 0;
    this.drawers.forEach((item) => { item.classList.remove('is-open'); item.setAttribute('aria-hidden', 'true'); });
    this.overlay.hidden = false;
    requestAnimationFrame(() => { this.overlay.classList.add('is-open'); drawer.classList.add('is-open'); });
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('dh-lock');
    setTimeout(() => drawer.querySelector('button,input,a')?.focus(), 330);
  }

  closeDrawers() {
    this.drawers.forEach((item) => { item.classList.remove('is-open'); item.setAttribute('aria-hidden', 'true'); });
    this.overlay.classList.remove('is-open');
    document.body.classList.remove('dh-lock');
    setTimeout(() => this.overlay.hidden = true, 260);
    this.lastFocus?.focus?.();
  }

  onKeydown(event) {
    if (event.key === 'Escape') {
      if (this.sampleDialog?.open) { this.sampleDialog.close(); return; }
      this.closeMega(); this.closeDrawers();
    }
    if (event.key !== 'Tab') return;
    const drawer = this.drawers.find((item) => item.classList.contains('is-open'));
    if (!drawer) return;
    const focusable = [...drawer.querySelectorAll('a,button,input,summary,[tabindex]:not([tabindex="-1"])')].filter((el) => !el.disabled);
    if (!focusable.length) return;
    const first = focusable[0], last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }

  openBenefits() {
    const dialog = this.querySelector('[data-benefits-dialog]');
    if (dialog?.showModal) dialog.showModal();
  }

  async cartRequest(path = 'cart.js', body) {
    const reading = body === undefined;
    const controller = new AbortController();
    const timer = window.setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}${path}${reading ? `${path.includes('?') ? '&' : '?'}_sorella=${Date.now()}` : ''}`, {
        method: reading ? 'GET' : 'POST',
        headers: { Accept: 'application/json', ...(reading ? {} : { 'Content-Type': 'application/json' }) },
        ...(reading ? { cache: 'no-store' } : { body: JSON.stringify(body) }),
        signal: controller.signal
      });
      if (!response.ok) {
        const error = new Error(await this.cartErrorMessage(response, response.status === 429
          ? 'Your bag is busy. Please wait a moment, then try again.' : 'We could not refresh your bag. Please try again.'));
        error.status = response.status;
        throw error;
      }
      return await response.json();
    } catch (error) {
      if (!reading && !error.status) error.cartMayHaveChanged = true;
      if (error.name === 'AbortError') error = Object.assign(new Error('Your bag took too long to respond. Please check it before trying again.'), { cartMayHaveChanged: !reading });
      else if (!error.status && /failed to fetch|network|load failed|fetch failed/i.test(error.message || '')) {
        error = Object.assign(new Error('The connection was interrupted. Your bag is saved. Please check your bag before trying again.'), { cartMayHaveChanged: !reading });
      }
      throw error;
    } finally { window.clearTimeout(timer); }
  }

  async runCartMutation(task) {
    this.cartPendingMutations = (this.cartPendingMutations || 0) + 1;
    this.setCartBusy(true);
    const previous = this.cartMutationQueue || Promise.resolve();
    const operation = previous.catch(() => {}).then(async () => {
      if (this.cartLoadPromise) await this.cartLoadPromise;
      return task();
    });
    this.cartMutationQueue = operation;
    try { return await operation; }
    finally {
      this.cartPendingMutations -= 1;
      if (!this.cartPendingMutations) {
        this.setCartBusy(false);
        await this.loadCart();
      }
    }
  }

  setCartBusy(busy) {
    this.querySelector('[data-cart-content]')?.classList.toggle('is-updating', busy);
    this.querySelectorAll('[data-sample-add]').forEach((button) => { button.disabled = busy || button.dataset.soldOut === 'true'; });
    this.querySelectorAll('.dh__cart-checkout').forEach((button) => { button.disabled = busy; });
  }

  sampleThreshold() { return Number(this.rewardPolicy?.thresholdCents || Number(this.sampleDialog?.dataset.unlockAmount || 1250) * 100); }

  // Black Friday sale days pause the free-tester and free-shipping offers (see snippets/sorella-black-friday.liquid).
  saleActive() { try { return Boolean(window.SorellaSale?.active?.()); } catch (_) { return false; } }

  isManagedSampleItem(item) { return item.properties?._sorella_free_sample === 'true'; }

  verifiedRewardRequests() {
    if (!this.verifiedRewardRequestIds) {
      let saved = [];
      try { saved = JSON.parse(window.sessionStorage.getItem('sorella:verified-reward-requests:v1') || '[]'); } catch (_) {}
      this.verifiedRewardRequestIds = new Set(Array.isArray(saved) ? saved.filter((id) => typeof id === 'string').slice(-100) : []);
    }
    return this.verifiedRewardRequestIds;
  }

  rememberVerifiedRewardRequest(id) {
    if (!id) return;
    const verified = this.verifiedRewardRequests();
    verified.add(id);
    try { window.sessionStorage.setItem('sorella:verified-reward-requests:v1', JSON.stringify([...verified].slice(-100))); } catch (_) {}
  }

  rewardUnits(item) {
    // Shopify requires unique automatic-discount titles, so the tester offer's scheduled segments each have
    // their own title; the policy lists all of them (discountTitles), falling back to the single legacy title.
    const titles = Array.isArray(this.rewardPolicy?.discountTitles) && this.rewardPolicy.discountTitles.length
      ? this.rewardPolicy.discountTitles
      : [this.rewardPolicy?.discountTitle || 'Sorella Complimentary 5ml — canonical inventory'];
    if (this.rewardPolicy?.testerVariantIds?.length && !this.rewardPolicy.testerVariantIds.includes(String(item.variant_id))) return 0;
    const quantity = Number(item.quantity || 0);
    const unitPrice = Number(item.original_price || (quantity ? item.original_line_price / quantity : 0));
    const allocated = (item.line_level_discount_allocations || []).reduce((sum, allocation) =>
      sum + (titles.includes(allocation.discount_application?.title) ? Number(allocation.amount || 0) : 0), 0);
    return unitPrice > 0 ? Math.min(quantity, Math.floor(allocated / unitPrice)) : 0;
  }

  rewardState(cart) {
    const items = cart.items || [];
    const shippingBlocked = items.some((item) => this.isRewardBlockingExperience(item, false));
    const shippingSubtotal = shippingBlocked ? 0 : items.reduce((sum, item) =>
      sum + (this.isManagedSampleItem(item) ? 0 : Number(item.final_line_price || 0)), 0);
    const blockingTitles = this.rewardPolicy?.nonCombinableDiscountTitles || [];
    const blocked = items.some((item) => this.isRewardBlockingExperience(item)) || (cart.cart_level_discount_applications || [])
      .some((discount) => blockingTitles.includes(discount.title) && Number(discount.total_allocated_amount) > 0);
    const eligibleIds = this.rewardPolicy?.eligibleProductIds;
    const subtotal = items.reduce((sum, item) => {
      const handle = String(item.handle || '').toLowerCase();
      const excluded = item.properties?._sorella_experience === 'mystery' || handle === 'sorella-mystery-bag';
      if (excluded || this.isManagedSampleItem(item) || (Array.isArray(eligibleIds) && !eligibleIds.includes(String(item.product_id)))) return sum;
      return sum + Number(item.final_line_price || 0);
    }, 0);
    const rewardCount = items.reduce((sum, item) => sum + this.rewardUnits(item), 0);
    const enabled = !this.saleActive() && this.rewardPolicy?.enabled !== false && (!this.rewardPolicy?.currency || cart.currency === this.rewardPolicy.currency);
    return { blocked, subtotal: blocked ? 0 : subtotal, shippingBlocked, shippingSubtotal, hasReward: enabled && !blocked && rewardCount === 1, rewardCount,
      eligible: enabled && !blocked && subtotal >= this.sampleThreshold(), managed: items.filter((item) => this.isManagedSampleItem(item)) };
  }

  rewardCartSignature(cart) {
    return JSON.stringify({ items: (cart.items || []).map((item) => [String(item.variant_id), item.quantity, item.final_line_price, item.properties || {}])
      .sort((left, right) => JSON.stringify(left).localeCompare(JSON.stringify(right))), codes: cart.discount_codes || [] });
  }

  async reconcileRewardCart(cart) {
    const state = this.rewardState(cart);
    const updates = {};
    let retained = false;
    for (const item of state.managed) {
      const requestId = item.properties?._sorella_reward_request_id;
      const legacySafe = (this.rewardUnits(item) > 0 && Number(item.final_line_price) === 0)
        || (requestId && this.verifiedRewardRequests().has(requestId));
      const failed = requestId && this.failedRewardRequestIds?.has(requestId);
      const keep = !retained && state.hasReward && legacySafe && !failed && item.properties?._sorella_inventory_source === 'canonical-5ml-variant';
      if (keep) retained = true;
      if (!keep || Number(item.quantity) !== 1) updates[item.key] = keep ? 1 : 0;
    }
    const clearAbsentFailures = (current) => {
      for (const id of this.failedRewardRequestIds || []) {
        if (!current.items.some((item) => item.properties?._sorella_reward_request_id === id)) this.failedRewardRequestIds.delete(id);
      }
    };
    clearAbsentFailures(cart);
    if (!Object.keys(updates).length) return cart;
    // One bounded reconciliation. An error must never become a GET/POST loop.
    await this.cartRequest('cart/update.js', { updates });
    const fresh = await this.cartRequest();
    clearAbsentFailures(fresh);
    const next = this.rewardState(fresh);
    if (next.managed.length > 1 || next.managed.some((item) => Number(item.quantity) !== 1 || !next.hasReward
      || item.properties?._sorella_inventory_source !== 'canonical-5ml-variant'
      || (!(this.rewardUnits(item) > 0 && Number(item.final_line_price) === 0) && !this.verifiedRewardRequests().has(item.properties?._sorella_reward_request_id))
      || this.failedRewardRequestIds?.has(item.properties?._sorella_reward_request_id))) {
      throw new Error('Please remove the extra tester from your bag before checkout.');
    }
    return fresh;
  }

  async loadCart() {
    if (this.cartPendingMutations) return this.lastCart;
    if (this.cartLoadPromise) return this.cartLoadPromise;
    this.cartLoadPromise = this.refreshCart();
    try { return await this.cartLoadPromise; }
    finally { this.cartLoadPromise = null; }
  }

  async refreshCart() {
    const target = this.querySelector('[data-cart-content]');
    try {
      let cart = await this.cartRequest();
      this.lastCart = cart;
      cart = await this.reconcileRewardCart(cart);
      this.lastCart = cart;
      this.cartSafetyError = '';
      this.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
        const button = el.closest('[data-open-cart]');
        if (button) button.setAttribute('aria-label', `Open cart, ${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'}`);
      });
      const state = this.rewardState(cart);
      const { blocked: rewardsBlocked, subtotal: qualifyingSubtotal, hasReward: hasSample } = state;
      const sameSuppressedCart = this.sampleSuppressedCart === this.rewardCartSignature(cart);
      if (this.sampleSuppressedCart && !sameSuppressedCart) {
        this.sampleSuppressedCart = null;
        this.samplePromptShown = false;
      }
      if (hasSample && this.sampleDialog?.open) {
        this.sampleDialog.close();
        this.querySelectorAll('.dh__sample-error').forEach((node) => node.remove());
        this.rewardNotice = 'Your free 5ml tester is included in your bag.';
      }
      if (!hasSample && !sameSuppressedCart) this.rewardNotice = '';
      window.clearTimeout(this.samplePromptTimer);
      if (!state.eligible || hasSample) this.samplePromptShown = false;
      const rewards = this.renderRewards(qualifyingSubtotal, hasSample, rewardsBlocked, sameSuppressedCart,
        { subtotal: state.shippingSubtotal, blocked: state.shippingBlocked });
      const notice = this.rewardNotice ? `<p class="dh__cart-notice" role="status">${this.escape(this.rewardNotice)}</p>` : '';
      if (!cart.item_count) {
        target.innerHTML = `<div class="dh__cart-scroll">${rewards}<div class="dh__cart-empty"><h3>Your Sorella bag is waiting.</h3><p>Add a perfume to begin unlocking your rewards.</p><nav><a href="/collections/all-perfumes">Shop all perfumes</a><a href="/collections/sorella-originals">Sorella Originals</a><a href="/pages/sorella-discovery-set">Discovery Set</a></nav></div></div>`;
        return;
      }
      const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style:'currency', currency:cart.currency || 'USD' }).format(cents / 100);
      target.innerHTML = `<div class="dh__cart-scroll">${rewards}${notice}${this.renderCartLines(cart.items, money)}` + `${cart.cart_level_discount_applications?.map((discount) => `<p class="dh__cart-discount">${this.escape(discount.title)} <strong>−${money(discount.total_allocated_amount)}</strong></p>`).join('') || ''}</div><div class="dh__cart-footer"><div class="dh__cart-total"><span>Subtotal</span><strong>${money(cart.total_price)}</strong></div><p>Shipping and taxes calculated at checkout.</p><form action="${window.Shopify?.routes?.root || '/'}cart" method="post"><button class="dh__cart-checkout" type="submit" name="checkout">CHECKOUT · ${money(cart.total_price)}</button></form></div>`;
      if (state.eligible && !hasSample && !this.samplePromptShown && !sameSuppressedCart) {
        this.samplePromptShown = true;
        this.samplePromptTimer = window.setTimeout(() => this.openSamples(), 360);
      }
      return cart;
    } catch (error) {
      this.cartSafetyError = error.message;
      if (target) target.innerHTML = `<p role="alert">${this.escape(error.message)} Your bag is saved. <a href="${window.Shopify?.routes?.root || '/'}cart">Review your bag</a></p>`;
      return null;
    }
  }

  isFreeSampleItem(item) {
    return this.rewardUnits(item) > 0;
  }

  async guardCheckout(event) {
    const form = event.target;
    if (!form?.matches?.('form') || !(event.submitter?.name === 'checkout') ||
      !(this.contains(form) || form.classList.contains('dcore-cart'))) return;
    event.preventDefault();
    if (this.checkingCheckout) return;
    const edited = [...form.querySelectorAll('[name="updates[]"]')].some((input) => input.value !== input.defaultValue);
    if (edited) {
      this.showCartError('Please use Update cart to save your quantities before checkout.', form);
      return;
    }
    this.checkingCheckout = true;
    try {
      await this.runCartMutation(async () => {
        const cart = await this.reconcileRewardCart(await this.cartRequest());
        const state = this.rewardState(cart);
        if (state.managed.length && !state.hasReward) throw new Error('Please remove the extra tester from your bag before checkout.');
        this.lastCart = cart;
      });
      if (this.cartSafetyError) throw new Error(this.cartSafetyError);
      window.location.assign(`${window.Shopify?.routes?.root || '/'}checkout`);
    } catch (error) { this.showCartError(error.message, form); }
    finally { this.checkingCheckout = false; }
  }

  showCartError(message, fallback) {
    const target = fallback?.isConnected ? fallback : this.querySelector('[data-cart-content]');
    target?.querySelectorAll('.dh__cart-error').forEach((node) => node.remove());
    target?.insertAdjacentHTML('afterbegin', `<p class="dh__cart-error" role="alert">${this.escape(message)}</p>`);
  }

  isRewardBlockingExperience(item, includeDiscounts = true) {
    const properties = item.properties || {};
    const experience = String(properties._sorella_experience || '').toLowerCase();
    if (properties._sorella_rewards_excluded === 'true' || experience === 'bundle' || experience === 'discovery') return true;
    if (includeDiscounts && (item.line_level_discount_allocations || []).some((allocation) =>
      Number(allocation.amount) > 0 && (this.rewardPolicy?.nonCombinableDiscountTitles || []).includes(allocation.discount_application?.title))) return true;
    const handle = String(item.handle || '').toLowerCase();
    const url = String(item.url || '').toLowerCase();
    const type = String(item.product_type || '').toLowerCase();
    const title = String(item.product_title || '').toLowerCase();
    return handle === 'sorella-bundle-selection'
      || handle === 'sorella-discovery-set-selection'
      || url.includes('/products/sorella-bundle-selection')
      || url.includes('/products/sorella-discovery-set-selection')
      || type.includes('bundle selection')
      || type.includes('discovery set selection')
      || title.includes('sorella bundle selection')
      || title.includes('sorella discovery set selection');
  }

  cartComponents(item) {
    if (Array.isArray(item?.item_components)) return item.item_components;
    if (Array.isArray(item?.components)) return item.components;
    return [];
  }

  renderCartLines(items, money) {
    const renderedGroups = new Set();
    return items.map((item) => {
      const experience = item.properties?._sorella_experience;
      const groupId = item.properties?._sorella_group_id;
      if (!experience || !groupId) return this.renderCartItem(item, money);
      const groupKey = `${experience}:${groupId}`;
      if (renderedGroups.has(groupKey)) return '';
      renderedGroups.add(groupKey);
      const nestedComponents = this.cartComponents(item);
      const isNativeGroup = nestedComponents.length > 0;
      const group = isNativeGroup
        ? nestedComponents
        : items.filter((candidate) => candidate.properties?._sorella_experience === experience && candidate.properties?._sorella_group_id === groupId);
      const title = experience === 'discovery' ? 'Sorella Discovery Set' : 'Your Sorella Bundle';
      const sourceKey = (candidate) => candidate.properties?._sorella_source_handle || candidate.variant_id || candidate.product_id;
      const valid = experience === 'discovery'
        ? group.reduce((sum, candidate) => sum + candidate.quantity, 0) === 6 && new Set(group.map(sourceKey)).size === 6
        : [2, 3].includes(new Set(group.map(sourceKey)).size);
      const total = isNativeGroup ? item.final_line_price : group.reduce((sum, candidate) => sum + candidate.final_line_price, 0);
      const originalTotal = isNativeGroup ? item.original_line_price : group.reduce((sum, candidate) => sum + candidate.original_line_price, 0);
      const bundleDiscount = new Set(group.map(sourceKey)).size === 3 ? 15 : 10;
      const pricingLabel = experience === 'bundle'
        ? (valid ? `${bundleDiscount}% bundle discount` : 'Regular item pricing')
        : (valid ? 'Six-scent discovery price' : 'Regular item pricing');
      const warning = experience === 'bundle'
        ? 'This bundle is incomplete. Its remaining items keep their regular prices.'
        : 'This edit is incomplete, so its offer has been removed.';
      const discountedTotal = originalTotal > total ? `<s>${money(originalTotal)}</s><strong>${money(total)}</strong>` : `<strong>${money(total)}</strong>`;
      return `<section class="dh__experience-group${valid ? '' : ' is-incomplete'}"><header><div><span>${experience === 'discovery' ? '6 × 5ML EDIT' : `${group.length} SCENT EDIT`}</span><strong>${title}</strong></div><button type="button" data-cart-remove-group="${this.escape(groupId)}">Remove set</button></header>${valid ? '' : `<p class="dh__experience-warning">${warning}</p>`}<div>${group.map((candidate) => this.renderCartItem(candidate, money, true, isNativeGroup)).join('')}</div><footer><span>${pricingLabel}</span><span class="dh__experience-price">${discountedTotal}</span></footer></section>`;
    }).join('');
  }

  renderCartItem(item, money, compact = false, component = false) {
    const sample = this.isFreeSampleItem(item);
    const managed = this.isManagedSampleItem(item);
    const fullyFree = sample && Number(item.final_line_price) === 0;
    const sourceTitle = item.properties?.Scent || item.product_title;
    const sourceSize = item.properties?.Size || (item.variant_title === 'Default Title' ? (sample ? 'Complimentary 5ml tester' : '50ml / 1.7oz') : item.variant_title || '');
    const sourceHandle = item.properties?._sorella_source_handle;
    const itemUrl = sourceHandle ? `/products/${encodeURIComponent(sourceHandle)}` : item.url;
    const remove = component ? '' : `<button class="dh__remove" data-cart-change data-key="${this.escape(item.key)}" data-quantity="0">Remove</button>`;
    const linePrice = component || !Number.isFinite(item.final_line_price)
      ? ''
      : `<span class="dh__line-price">${item.original_line_price > item.final_line_price ? `<s>${money(item.original_line_price)}</s>` : ''}<strong>${fullyFree ? 'FREE' : money(item.final_line_price)}</strong></span>`;
    const rewardLabel = sample ? `<span class="dh__sample-line-label">${fullyFree ? 'YOUR FREE TESTER' : 'INCLUDES 1 FREE TESTER'}</span>` : '';
    const quantity = compact || (managed && Number(item.quantity) === 1) ? '' : `<div class="dh__quantity"><button data-cart-change data-key="${this.escape(item.key)}" data-quantity="${item.quantity - 1}" aria-label="Decrease ${this.escape(sourceTitle)}">−</button><span>${item.quantity}</span><button data-cart-change data-key="${this.escape(item.key)}" data-quantity="${item.quantity + 1}" aria-label="Increase ${this.escape(sourceTitle)}">+</button></div>`;
    return `<article class="dh__cart-item${sample ? ' is-sample' : ''}${compact ? ' is-experience-item' : ''}${component ? ' is-component' : ''}"><a href="${this.escape(itemUrl || '#')}"><img src="${this.escape(item.image || '')}" alt="${this.escape(sourceTitle)}"></a><div class="dh__cart-item-copy"><strong>${this.escape(sourceTitle)}</strong><p>${this.escape(sourceSize)}</p>${rewardLabel}${quantity}${remove}</div>${linePrice}</article>`;
  }

  renderRewards(subtotal, hasSample, rewardsBlocked = false, sampleConflict = false, shippingState = null) {
    if (this.saleActive()) return '<section class="dh__rewards is-sale" aria-label="Sorella Black Friday"><div class="dh__reward-feedback"><p><strong>Black Friday prices apply automatically in your bag.</strong> The free tester and free shipping offers return after the sale.</p></div></section>';
    const shippingAmount = Number(this.sampleDialog?.dataset.shippingAmount || 1500) * 100;
    const sampleAmount = this.sampleThreshold();
    const shippingSubtotal = shippingState?.subtotal ?? subtotal;
    const shippingBlocked = shippingState?.blocked ?? rewardsBlocked;
    const shippingUnlocked = !shippingBlocked && shippingSubtotal >= shippingAmount;
    const sampleEnabled = this.rewardPolicy?.enabled !== false && (!this.rewardPolicy?.currency || !this.lastCart?.currency || this.lastCart.currency === this.rewardPolicy.currency);
    const sampleUnlocked = !rewardsBlocked && !sampleConflict && (hasSample || subtotal >= sampleAmount) && sampleEnabled;
    const finalMilestone = Math.max(shippingAmount, sampleAmount);
    const progressSubtotal = Math.max(rewardsBlocked ? 0 : subtotal, shippingBlocked ? 0 : shippingSubtotal);
    const progress = Math.max(0, Math.min(100, (progressSubtotal / finalMilestone) * 100));
    const truck = '<svg viewBox="0 0 28 18" aria-hidden="true"><path d="M1 2h16v11H1zM17 6h5l4 4v3h-9z"/><circle cx="6" cy="15" r="2"/><circle cx="21" cy="15" r="2"/></svg>';
    const gift = '<svg viewBox="0 0 20 22" aria-hidden="true"><path d="M2 8h16v12H2zM1 5h18v4H1zM10 5v15M10 5C8 1 4 1 4 3c0 2 3 2 6 2Zm0 0c2-4 6-4 6-2 0 2-3 2-6 2Z"/></svg>';
    const steps = [
      { badge:gift, label:'FREE 5ML TESTER', active:sampleUnlocked, at:(sampleAmount / finalMilestone) * 100, key:'sample' },
      { badge:truck, label:'FREE SHIPPING', active:shippingUnlocked, at:(shippingAmount / finalMilestone) * 100, key:'shipping' }
    ].sort((a, b) => a.at - b.at);
    const remainingShipping = Math.max(0, (shippingAmount - shippingSubtotal) / 100);
    const remainingSample = Math.max(0, (sampleAmount - subtotal) / 100);
    let message = `${this.formatAmount(remainingSample)} to your free 5ml tester.`;
    if (sampleUnlocked && !shippingUnlocked && !hasSample) message = `<strong>Your free 5ml tester is unlocked.</strong> ${this.formatAmount(remainingShipping)} to free shipping.`;
    if (sampleUnlocked && !shippingUnlocked && hasSample) message = `<strong>Your free 5ml tester is added.</strong> ${this.formatAmount(remainingShipping)} to free shipping.`;
    if (shippingUnlocked && !hasSample) message = sampleUnlocked
      ? '<strong>Free shipping + free 5ml tester unlocked.</strong>'
      : `<strong>Free shipping is unlocked.</strong> ${this.formatAmount(remainingSample)} in eligible items to your free 5ml tester.`;
    if (shippingUnlocked && hasSample) message = '<strong>Free shipping + free 5ml tester unlocked.</strong>';
    if (sampleConflict) message = 'Your current offer cannot be combined with a free tester. Review your bag or discount.' + (shippingUnlocked ? ' Free shipping is unlocked.' : '');
    if (rewardsBlocked) message = shippingBlocked
      ? '<strong>Cart rewards do not apply to this order.</strong> Discovery Sets and custom bundles are excluded from free 5ml perfume and free shipping offers.'
      : 'Your tester offer cannot be combined with a free 5ml tester.' + (shippingUnlocked ? ' Free shipping is unlocked.' : ` ${this.formatAmount(remainingShipping)} to free shipping.`);
    const choose = !rewardsBlocked && sampleUnlocked && !hasSample ? '<button type="button" data-open-samples>Choose sample</button>' : '';
    const currentStep = shippingUnlocked ? 'shipping' : sampleUnlocked ? 'sample' : '';
    return `<section class="dh__rewards${rewardsBlocked ? ' is-blocked' : ''}" aria-label="Sorella cart rewards"><div class="dh__reward-track"><i style="width:${progress}%"></i>${steps.map((step) => `<div class="dh__reward-step dh__reward-step--${step.key}${step.active ? ' is-active' : ''}${step.key === currentStep ? ' is-current' : ''}" style="left:${step.at}%"><span class="dh__reward-badge">${step.badge}</span><small>${step.label}</small></div>`).join('')}</div><div class="dh__reward-feedback"><p>${message}</p>${choose}</div></section>`;
  }

  formatAmount(amount) {
    const currency = this.lastCart?.currency || 'EGP';
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style:'currency', currency, maximumFractionDigits:0
    }).format(amount);
  }

  async cartErrorMessage(response, fallback = 'We could not update your cart. Please try again.') {
    const payload = await response.clone().json().catch(() => null);
    const raw = payload?.description || payload?.message || payload?.errors;
    const message = typeof raw === 'string'
      ? raw
      : (raw && typeof raw === 'object' ? Object.values(raw).flat().filter(Boolean).join(' ') : '');
    if (!message) {
      if (response.status === 422) return 'This size is sold out or no longer available.';
      return fallback;
    }
    if (/sold\s*out|out\s*of\s*stock|not\s+enough\s+(?:items\s+)?in\s+stock|unavailable|not\s+available/i.test(message)) {
      return 'This size is sold out or no longer available.';
    }
    if (/all\s+\d+|only\s+\d+|maximum|quantity|stock/i.test(message)) return message;
    return message;
  }

  async openSamples() {
    if (!this.sampleDialog?.showModal || this.cartPendingMutations || !this.lastCart) return;
    const state = this.rewardState(this.lastCart);
    if (!state.eligible || state.hasReward || this.cartSafetyError || this.sampleSuppressedCart === this.rewardCartSignature(this.lastCart)) return;
    if (!this.sampleDialog.open) this.sampleDialog.showModal();
    await this.loadSamples();
  }

  async loadSamples() {
    if (this.sampleLoadPromise) return this.sampleLoadPromise;
    this.sampleLoadPromise = this.refreshSamples();
    try { return await this.sampleLoadPromise; } finally { this.sampleLoadPromise = null; }
  }

  async refreshSamples() {
    const target = this.querySelector('[data-sample-products]');
    target.innerHTML = '<p class="dh__sample-loading">Finding your available testers…</p>';
    const configured = this.sampleDialog?.dataset.testersUrl || '/collections/5ml-testers';
    const controller = new AbortController();
    const timer = window.setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(`${configured.replace(/\/$/, '')}/products.json?limit=100&_sorella=${Date.now()}`, { headers:{ Accept:'application/json' }, cache:'no-store', signal:controller.signal });
      if (!response.ok) throw new Error('Canonical tester collection unavailable');
      const products = (await response.json()).products || [];
      const seen = new Set();
      this.sampleVariants = products.flatMap((product) => {
        const variant = (product.variants || []).find((candidate) => {
          const sizes = [candidate.title, candidate.option1, candidate.option2, candidate.option3]
            .map((value) => String(value || '').replace(/\s/g, '').toLowerCase());
          return candidate.available && sizes.includes('5ml') && (!this.rewardPolicy?.testerVariantIds?.length || this.rewardPolicy.testerVariantIds.includes(String(candidate.id)));
        });
        if (!variant || seen.has(String(variant.id))) return [];
        seen.add(String(variant.id));
        return [{
          id: String(variant.id),
          title: product.title,
          variant: '5ml tester',
          handle: product.handle,
          sku: variant.sku || '',
          image: variant.featured_image?.src || product.images?.[0]?.src || product.image?.src || ''
        }];
      });
      target.innerHTML = this.sampleVariants.length ? this.sampleVariants.map((sample) => `<article class="dh__sample-product"><img src="${this.escape(sample.image)}" alt=""><div><strong>${this.escape(sample.title)}</strong><span>${this.escape(sample.variant)}</span><small>FREE</small></div><button type="button" data-sample-add data-variant-id="${this.escape(sample.id)}">Add</button></article>`).join('') : '<p class="dh__sample-empty">No 5ml testers are available right now. Please check again soon.</p>';
      this.setCartBusy(Boolean(this.cartPendingMutations));
    } catch (_) {
      target.innerHTML = '<p class="dh__sample-empty">We could not load the available testers. Please try again.</p>';
    } finally { window.clearTimeout(timer); }
  }

  async addFreeSample(variantId, button) {
    const sample = this.sampleVariants?.find((variant) => variant.id === String(variantId));
    if (!sample || this.sampleAdding || button.disabled) return;
    this.sampleAdding = true;
    this.querySelectorAll('.dh__sample-error').forEach((node) => node.remove());
    button.textContent = 'Adding…';
    let attemptedRequestId = '';
    let startingTotal = Infinity;
    try {
      await this.runCartMutation(async () => {
        const currentCart = await this.reconcileRewardCart(await this.cartRequest());
        const state = this.rewardState(currentCart);
        if (state.hasReward) {
          this.rewardNotice = 'Your free 5ml tester is already included in your bag.';
          this.sampleDialog.close();
          return;
        }
        if (state.blocked) throw new Error('Discovery Sets and custom bundles are not eligible for the free 5ml perfume offer.');
        if (!state.eligible) throw new Error(`Spend ${this.formatAmount(this.sampleThreshold() / 100)} on eligible items to unlock your free 5ml perfume.`);
        const requestId = globalThis.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(16).slice(2)}`;
        attemptedRequestId = requestId;
        startingTotal = Number(currentCart.total_price);
        let addError;
        try { await this.cartRequest('cart/add.js', { items:[{ id:Number(variantId), quantity:1, properties:{
        _sorella_free_sample:'true',
        _sorella_inventory_source:'canonical-5ml-variant',
        _sorella_reward_request_id:requestId,
        _sorella_source_handle:sample.handle || '',
        _sorella_source_sku:sample.sku || '',
        Reward:'Free 5ml tester',
        Scent:sample.title,
        Size:'5ml'
        } }] }); } catch (error) {
          if (!error.cartMayHaveChanged) throw error;
          addError = error;
        }
        // An uncertain add is resolved by reading the cart, never by repeating the add.
        const verifiedCart = await this.cartRequest().catch((error) => {
          // A single extra read can resolve a transient connection failure.
          if (error.status === 429 || (error.status && error.status < 500)) throw error;
          return this.cartRequest();
        });
        const selected = verifiedCart.items?.find((item) => item.properties?._sorella_reward_request_id === requestId);
        const verified = this.rewardState(verifiedCart);
        if (!selected || Number(selected.quantity) !== 1 || !verified.hasReward || Number(verifiedCart.total_price) > Number(currentCart.total_price)) {
          let restored = verifiedCart;
          if (selected?.key) {
            this.failedRewardRequestIds ||= new Set();
            this.failedRewardRequestIds.add(requestId);
            await this.cartRequest('cart/update.js', { updates: { [selected.key]: 0 } });
            restored = await this.cartRequest();
            if (restored.items.some((item) => item.properties?._sorella_reward_request_id === requestId)) throw new Error('Please remove the extra tester from your bag before checkout.');
            this.failedRewardRequestIds.delete(requestId);
          }
          this.sampleSuppressedCart = this.rewardCartSignature(restored);
          const conflict = verified.blocked
            ? 'Adding this tester would use a different tester offer. It cannot be combined with a free tester. Your extra tester was removed; please review your bag.'
            : verifiedCart.discount_codes?.some((discount) => discount.applicable)
              ? 'Your current discount could not be combined with this free tester. Keep your discount, or remove it and choose your tester again. The extra tester was removed.'
              : 'This offer could not be applied with the current items or discounts in your bag. No extra tester was charged. Please review your bag.';
          this.rewardNotice = conflict;
          throw new Error(addError?.message || conflict);
        }
        this.rewardNotice = Number(selected.final_line_price) === 0
          ? 'Your free 5ml tester is added.'
          : 'Your free tester saving is applied to another 5ml tester in your bag. The total has not increased.';
        this.rememberVerifiedRewardRequest(requestId);
        this.sampleDialog.close();
        document.dispatchEvent(new CustomEvent('sorella:cart:updated'));
      });
    } catch (error) {
      const recovered = !this.cartSafetyError && attemptedRequestId && this.lastCart?.items?.find((item) => item.properties?._sorella_reward_request_id === attemptedRequestId);
      if (recovered && !this.failedRewardRequestIds?.has(attemptedRequestId) && Number(recovered.quantity) === 1 && this.rewardState(this.lastCart).hasReward && Number(this.lastCart.total_price) <= startingTotal) {
        this.rememberVerifiedRewardRequest(attemptedRequestId);
        this.rewardNotice = 'Your free 5ml tester is added.';
        this.sampleDialog.close();
        return;
      }
      const soldOut = error.status === 422 && /sold\s*out|stock|unavailable|not available|no longer available/i.test(error.message);
      if (soldOut) button.dataset.soldOut = 'true';
      button.textContent = soldOut ? 'Sold out' : 'Try again';
      button.closest('article')?.insertAdjacentHTML('beforeend', `<p class="dh__sample-error" role="status">${this.escape(error.message)}</p>`);
    } finally { this.sampleAdding = false; this.setCartBusy(Boolean(this.cartPendingMutations)); }
  }

  async changeCart(key, quantity) {
    try {
      await this.runCartMutation(async () => {
      const changedCart = await this.cartRequest('cart/change.js', { id:key, quantity });
      const hadExperience = this.lastCart?.items?.some((item) => item.properties?._sorella_experience);
      const hasExperience = changedCart.items?.some((item) => item.properties?._sorella_experience);
      if ((hadExperience || hasExperience) && window.SorellaExperiences?.reconcileDiscounts) await window.SorellaExperiences.reconcileDiscounts(changedCart);
      document.dispatchEvent(new CustomEvent('sorella:cart:updated'));
      });
    } catch (error) {
      this.showCartError(error.message);
    }
  }

  async removeCartGroup(groupId) {
    try {
      await this.runCartMutation(async () => {
      const current = await this.cartRequest();
      const items = current.items?.filter((item) => item.properties?._sorella_group_id === groupId) || [];
      if (!items.length) return;
      const updates = Object.fromEntries(items.map((item) => [item.key, 0]));
      const changedCart = await this.cartRequest('cart/update.js', { updates });
      if (window.SorellaExperiences?.reconcileDiscounts) await window.SorellaExperiences.reconcileDiscounts(changedCart);
      document.dispatchEvent(new CustomEvent('sorella:cart:updated'));
      });
    } catch (error) {
      this.showCartError(error.message);
    }
  }

  async predict(query) {
    const target = this.searchResults || this.querySelector('[data-search-results]');
    const cleanQuery = query.trim();
    const sequence = ++this.searchSequence;
    if (cleanQuery.length < 2) {
      target.classList.remove('is-predictive');
      target.removeAttribute('aria-busy');
      target.innerHTML = this.defaultSearchMarkup;
      return;
    }
    target.classList.add('is-predictive');
    target.setAttribute('aria-busy', 'true');
    const localProducts = this.smartSearch(cleanQuery).slice(0, 10);
    if (localProducts.length) {
      if (sequence !== this.searchSequence) return;
      this.renderSearchResults(target, cleanQuery, localProducts);
      return;
    }
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}search/suggest.json?q=${encodeURIComponent(cleanQuery)}&resources[type]=product&resources[limit]=10`);
      if (!response.ok) throw new Error('Search failed');
      const data = await response.json();
      if (sequence !== this.searchSequence) return;
      const products = data.resources?.results?.products || [];
      this.renderSearchResults(target, cleanQuery, products.map((product) => ({ ...product, context:'' })));
    } catch (_) {
      if (sequence !== this.searchSequence) return;
      target.removeAttribute('aria-busy');
      target.innerHTML = '<p class="dh__search-empty">No matching Sorella scents yet.</p>';
    }
  }

  smartSearch(query) {
    const normalizedQuery = this.normalizeSearch(query);
    const tokenGroups = normalizedQuery.split(' ').filter(Boolean).map((token) => this.searchAliases(token));
    return (this.searchIndex || []).map((product) => {
      const title = this.normalizeSearch(product.title);
      const context = this.normalizeSearch(product.context);
      const terms = this.normalizeSearch(`${product.terms || ''} ${product.title || ''} ${product.context || ''}`);
      const matches = tokenGroups.every((alternatives) => alternatives.some((term) => terms.includes(term)));
      if (!matches) return null;
      let score = 0;
      if (title === normalizedQuery) score += 120;
      if (title.startsWith(normalizedQuery)) score += 80;
      if (title.includes(normalizedQuery)) score += 55;
      if (context.includes(normalizedQuery)) score += 35;
      if (terms.includes(normalizedQuery)) score += 25;
      tokenGroups.forEach((alternatives) => {
        if (alternatives.some((term) => title.includes(term))) score += 12;
        else if (alternatives.some((term) => context.includes(term))) score += 8;
        else score += 3;
      });
      return { product, score };
    }).filter(Boolean).sort((a, b) => b.score - a.score || a.product.title.localeCompare(b.product.title)).map((entry) => entry.product);
  }

  normalizeSearch(value) {
    return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, ' ').trim();
  }

  searchAliases(token) {
    const groups = [
      ['ysl','yves','saint','laurent'],
      ['pdm','parfums','marly'],
      ['armani','giorgio'],
      ['lancome','lancôme'],
      ['sdj','sol','janeiro'],
      ['ch','carolina','herrera'],
      ['kayali','kay'],
      ['tester','sample','5ml'],
      ['oil','rollon','roll']
    ];
    const group = groups.find((items) => items.includes(token));
    return group || [token];
  }

  isInternalOfferProduct(product) {
    const handle = String(product.handle || String(product.url || '').match(/\/products\/([^/?#]+)/i)?.[1] || '').toLowerCase();
    return ['sorella-mystery-bag', 'sorella-bundle-selection', 'sorella-discovery-set-selection', 'complimentary-5ml-sample'].includes(handle);
  }

  renderSearchResults(target, query, products) {
    products = products.filter((product) => !this.isInternalOfferProduct(product));
    target.removeAttribute('aria-busy');
    if (!products.length) {
      target.innerHTML = `<p class="dh__search-empty">No matching Sorella scents for “${this.escape(query)}”.</p>`;
      return;
    }
    target.innerHTML = `<section class="dh__smart-search" aria-live="polite"><header><span>SCENT RESULTS</span><strong>${products.length} matches for “${this.escape(query)}”</strong></header><div>${products.map((product) => `<a class="dh__predictive-item" href="${this.escape(product.url)}"><img src="${this.escape(product.image || '')}" alt=""><span class="dh__predictive-copy"><strong>${this.escape(product.title)}</strong>${product.context ? `<small>${this.escape(product.context)}</small>` : ''}<span>${this.escape(product.price || '')}</span></span><b aria-hidden="true">→</b></a>`).join('')}</div></section>`;
  }

  debounce(fn, wait) { let timer; return (...args) => { clearTimeout(timer); timer = setTimeout(() => fn(...args), wait); }; }
  escape(value) { const div = document.createElement('div'); div.textContent = value == null ? '' : String(value); return div.innerHTML; }
}

if (!customElements.get('sorella-custom-header')) customElements.define('sorella-custom-header', SorellaCustomHeader);
